import SectionTitle from "@/components/misc/SectionTitle";
import { Text } from "@/components/text/Text";
import { useLanguageContext } from "@/context/LanguageContext";
import { CircularProgress } from "@mui/material";
import React from "react";

const BookNow: React.FC = () => {
  const { lang } = useLanguageContext();
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "20px",
        paddingBottom: "20px",
      }}
    >
      <SectionTitle title={lang.t("landing.booking.title")}>
        <Text>{lang.t("landing.booking.descriptionLine1")}</Text>
      </SectionTitle>
      <TimmaCalendar />
    </div>
  );
};

export default BookNow;

const TimmaCalendar = () => {
  const [loading, setLoading] = React.useState(true);
  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        position: "relative",
      }}
    >
      {loading && (
        <div
          style={{
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <CircularProgress />
        </div>
      )}
      <iframe
        title="Timma booking calendar"
        height="100%"
        width="100%"
        frameBorder="0"
        src="https://varaa.timma.fi/reservation/highhairroomoy"
        id="reservationIframe47500"
        onLoad={() => setLoading(false)}
      ></iframe>
    </div>
  );
};
